<span *ngIf="showRead" class="receipt read">
  <mitter-double-tick-icon></mitter-double-tick-icon>
</span>

<span *ngIf="showDelivered" class="receipt delivered">
  <mitter-double-tick-icon></mitter-double-tick-icon>
</span>

<span *ngIf="showReceived" class="receipt received">
  <mitter-single-tick-icon></mitter-single-tick-icon>
</span>

<span *ngIf="showSent" class="receipt sent">
  <mitter-single-tick-icon></mitter-single-tick-icon>
</span>
